import { createRouter, createWebHistory } from 'vue-router';
import LandingView from '@/views/LandingView.vue';
import SignInDialogView from '@/views/SignInDialogView.vue';
import { landingBeforeEnter } from './guards';

const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    {
      path: '/',
      name: 'landing',
      component: LandingView,
      beforeEnter: landingBeforeEnter,
    },
    {
      path: '/sign-in-dialog',
      name: 'sign-in-dialog',
      component: SignInDialogView,
    },
  ],
});

export default router;
